import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Mail, Loader, CheckCircle, AlertCircle, ArrowLeft } from 'lucide-react'
import { apiClient } from '@/services/api'
import styles from './AuthStandalone.module.css'

export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      await apiClient.initiatePasswordReset(email)
      setSent(true)
    } catch (err: any) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.emoji}>🥔⚓</div>
          <h1 className={styles.title}>
            {sent ? 'CHECK YOUR EMAIL' : 'FORGOT PASSWORD'}
          </h1>
          <p className={styles.subtitle}>
            {sent
              ? 'If an account with that email exists, we sent reset instructions.'
              : 'Enter your email and we\'ll send you a reset link.'}
          </p>
        </div>

        {error && (
          <div className={styles.errorAlert}>
            <AlertCircle className={styles.errorIcon} />
            <span className={styles.errorText}>{error}</span>
          </div>
        )}

        {sent ? (
          <div className={styles.successCenter}>
            <CheckCircle className={styles.successIcon} />
            <p className={styles.successText}>
              We sent a password reset link to{' '}
              <strong className={styles.highlightSecondary}>{email}</strong>.
              <br />Check your inbox and follow the instructions.
            </p>
            <Link to="/auth" className={styles.link}>
              BACK TO SIGN IN
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* Email field */}
            <div className={styles.formGroupWide}>
              <label className={styles.formLabel}>EMAIL</label>
              <div className={styles.inputContainer}>
                <Mail className={styles.inputIcon} />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className={styles.formInputNoRight}
                />
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className={styles.submitBtnSpaced}
            >
              {loading ? (
                <>
                  <Loader className={styles.spinnerIcon} />
                  SENDING...
                </>
              ) : (
                'SEND RESET LINK'
              )}
            </button>

            {/* Back link */}
            <div className={styles.backLink}>
              <Link to="/auth" className={styles.backLinkAnchor}>
                <ArrowLeft className="w-3.5 h-3.5" />
                Back to Sign In
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
